import { STATUS } from "@constants/status.hrm";
import { URLS } from "@constants/urls";

import api from "@helpers/api";
import { PaginationRequestType } from "@type/HRM/pagination";

import { PromotionDataType, PromotionResponseType } from "@type/HRM/promotions";

const { PROMOTIONS } = URLS;
const { SUCCESS, FAILED } = STATUS;

const apiEndPointBaseURL = `${process.env.REACT_APP_PROMOTION_SERVICE_URL}${process.env.REACT_APP_PROMOTION_SERVICE_PORT}/${process.env.REACT_APP_PROMOTION_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${PROMOTIONS}`;

export const getPromotionGroups = (() => {
  return async (
    data: PaginationRequestType,
  ): Promise<PromotionResponseType> => {
    const { page, size, search, status } = data;

    return api
      .get(`${apiEndPointBaseURL}`, {
        params: {
          page,
          size,
          search,
          status,
        },
      })
      .then((response) => {
        const { data, page, size, total } = response.data;

        return {
          data,
          pagination: {
            page,
            size,
            total,
          },
        };
      });
  };
})();

export const createPromotionGroup = (() => {
  return async (
    formData: any,
    afterEffect: (param: any) => void,
  ): Promise<{ data: PromotionDataType }> => {
    return api
      .post(apiEndPointBaseURL, {
        ...formData,
      })
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const updatePromotionGroup = (() => {
  return async (
    promotionId: number,
    employeeId: number[],
    afterEffect: (param: any) => void,
  ): Promise<{ data: PromotionDataType }> => {
    return api
      .post(`${apiEndPointBaseURL}/${promotionId}`, {
        employeeId,
      })
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();
